// src/context/HotjarContext.tsx
import React, { createContext, useContext, useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import ReactGA from "react-ga4";

export const ANALYTICS_COOKIE_NAME = "analytics_user_id";
const COOKIE_DAYS = 365;

function setCookie(name: string, value: string, days: number) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

export function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
}

// Extiende window para TypeScript
declare global {
  interface Window {
    hj?: (command: string, ...args: any[]) => void;
    dataLayer: any[];
  }
}

// Context
const AnalyticsContext = createContext<string | null>(null);
export const useAnalyticId = () => useContext(AnalyticsContext);

// Provider
export const AnalyticProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [analyticId, setAnalyticId] = useState<string | null>(null);

  const identifyHotjar = () => {
    if (typeof window.hj === "function" && analyticId) {
      window.hj("identify", analyticId, { tipo: "anonimo" });
    } else {
      setTimeout(() => identifyHotjar(), 100);
    }
  };
  const identifyGoogle = async () => {
    if (analyticId && ReactGA.isInitialized) {
      try {
        ReactGA.set({
          user_properties: {
            wp_user_id: analyticId,
          },
        });
      // eslint-disable-next-line no-empty
      } catch {}
    } else {
      setTimeout(() => identifyGoogle(), 100);
    }
  };
  useEffect(() => {
    identifyHotjar();
    identifyGoogle();
  }, [analyticId]);

  useEffect(() => {
    let id = getCookie(ANALYTICS_COOKIE_NAME);
    if (!id) {
      id = uuidv4();
      setCookie(ANALYTICS_COOKIE_NAME, id, COOKIE_DAYS);
    }
    setAnalyticId(id);
  }, []);

  return (
    <AnalyticsContext.Provider value={analyticId}>
      {children}
    </AnalyticsContext.Provider>
  );
};
